import {isString} from '@acng/frontend-bounty/std/value.js';
import {createCacheMap} from '@acng/frontend-bounty/cache';
import {fetchJSON} from '@acng/frontend-bounty/fetch';
import {Engine} from '@acng/frontend-stargazer';

import {registerPurge} from '../../core/purge.js';
import {user} from '../../user/user.js';
import {VERSION} from 'acng/core/service/env.js';

const cache = createCacheMap();

export const translateFeature = (() => {
  const engine = Engine.root.spawn('translate');

  registerPurge(engine.template);

  engine.source = ([featureName], insert) => {
    const src = `/language/${user.lang}/${featureName}?v=${VERSION}`;

    return cache(src, async () => {
      const translations = await fetchJSON(src);
      mapTranslationMarkup(translations);
      insert(translations);
    });
  };

  return engine;
})();

const REGEXP = /{{\W*([\w.]*)\W*}}/g;

/**
 * @typedef {{[key: string]: string | TranslationData}} TranslationData
 */

/**
 * @deprecated
 * @param {TranslationData} translations
 */
const mapTranslationMarkup = (translations) => {
  for (const [key, item] of Object.entries(translations)) {
    if (isString(item)) {
      let result = '';
      let match;
      let lastIndex = 0;
      REGEXP.lastIndex = 0;
      while ((match = REGEXP.exec(item))) {
        if (match.index > lastIndex) {
          result += item.substring(lastIndex, match.index);
        }
        result += `\${${match[1]}}`;
        lastIndex = REGEXP.lastIndex;
      }
      if (lastIndex < item.length) {
        result += item.substring(lastIndex);
      }
      translations[key] = result;
    } else {
      mapTranslationMarkup(item);
    }
  }
};

/**
 * @param {string|string[]} src
 * @param {Record<string, string | number | null | undefined>} [params]
 * @returns {Promise<string>}
 */
export async function t(src, params) {
  if (isString(src)) {
    src = src.split('.');
  }
  return (await translateFeature.render(...src)).toText(params);
}
